export default {
    routerName: '公告追加',
    routerNamePic: '画像カットアウト',
    announce: {
        name: '公告名',
        thumb: 'サムネイル',
        image: '画像',
        scope: '範囲',
        scope0: 'フォアグラウンド',
        scope1: 'バックグラウンド',
        scope2: '両方',
        level: 'レベル',
        level0: '普通',
        level1: '正常',
        level2: '重要',
        startTime: '開始日付',
        endTime: '終了日付',
        status: '状態',
        open: '有効',
        close: '無効',
        description: '記述',
    },
};
